import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DocumentHTML = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M4 7.5L4 4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V7.5M20 16.5V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20L4 16.5"
          stroke={color}
        />
        <path
          d="M3 8.5C3 7.94772 3.44772 7.5 4 7.5H20C20.5523 7.5 21 7.94772 21 8.5V15.5C21 16.0523 20.5523 16.5 20 16.5H4C3.44772 16.5 3 16.0523 3 15.5V8.5Z"
          stroke={color}
        />
        <path
          d="M6.32872 12.5994V11.7812L10.2151 9.9858V10.9943L7.45372 12.179L7.48497 12.125V12.2557L7.45372 12.2017L10.2151 13.3864V14.3949L6.32872 12.5994ZM13.3878 8.40909L11.5128 15.375H10.6122L12.4872 8.40909H13.3878ZM17.6691 12.5994L13.7828 14.3949V13.3864L16.5441 12.2017L16.5129 12.2557V12.125L16.5441 12.179L13.7828 10.9943V9.9858L17.6691 11.7812V12.5994Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DocumentHTML
